import React, { createContext, useContext, useState } from 'react';

const PageContext = createContext();

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext must be used within a PageProvider');
  }
  return context;
};

export const PageProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  const [showInfo, setShowInfo] = useState(false);
  const [infoCallback, setInfoCallback] = useState(null);
  const [reportInfo, setReportInfo] = useState(null);

  const setPageInfo = (title, showInfoButton = false, onInfoClick = null, reportData = null) => {
    setPageTitle(title);
    setShowInfo(showInfoButton);
    setInfoCallback(() => onInfoClick);
    setReportInfo(reportData);
  };

  const value = {
    pageTitle,
    showInfo,
    infoCallback,
    reportInfo,
    setPageInfo
  };

  return (
    <PageContext.Provider value={value}>
      {children}
    </PageContext.Provider>
  );
};